<div class="page" id="report-defs-collection-page">
	<div class="action-bar dark-bg with-tabs">
			<div class="title">Reportes</div>
			<div class="tabs">
				<a class="tab selected" href="#reportes?estado=E">En edición</a>
				<a class="tab" href="#reportes?estado=A">Activos</a>
				<a class="tab" href="#reportes?estado=I">Inactivos</a>
				<a class="tab" href="#reportes?estado=X">Eliminados</a>
				<a class="tab" href="#reportes?estado=*">Todos</a>
			</div>
			<div class="actions-set">
				<a class="action-btn back" href="#home"></a>
				<a class="action-btn search" href="#"></a>
				<a class="action-btn add" on:click={createReport}>Agregar un nuevo Reporte</a>
				<a class="action-btn sos" href="#">SOS</a>
			</div>
	</div>
	<div class="content">
		<div class="container">
			<div class="section" id="reportes">
				<div class="list-content">
          <ul class="content-grid">

            <BigAddButton 
              on:click={createReport}
              label="Agrega un nuevo reporte"
              />

            {#if isCurrent}
              <ReportDefsList />
            {/if}

          </ul>
        </div>
			</div>
		</div>
	</div>
</div>

<Overlay 
  bind:show={create} centered
  bg="dark">
  <Panel
    bg="surface" color="black"
    border shadow="lg" rounded="xs"
    px="lg" pt="md" pb="nm"
    maxw=42 line="double">

    <ReportDefCreateForm 
      bind:open={create}
      bind:rpt={rpt} 
      full
      />

  </Panel>
</Overlay>

<script>
  import { onMount } from 'svelte'
  import { Overlay, Panel, Box, Heading } from 'svelte-stylo'
  import { route } from '@/pager'
  import { BigAddButton } from '@/components'
  import API from '@/api'
  import { NULLUID, ReportDef, Account } from '@/models'
  import ReportDefsList from './ReportDefsList.svelte'
  import ReportDefCreateForm from './ReportDefCreateForm.svelte'  

  let
    page, 
    isCurrent = false,
    create = false,
    rpt;

  onMount(async () => {
    // to make this Page visible to the router 
    page = route({page:"#report-defs-collection-page", route: "#reportes"}) ;

    console.log("DONE: mounted ReportDefsCollectionPage to route '#reportes'");

    page.content = function(url, options) {
      console.log("ReportDefsCollectionPage: page.content url=", url)
      isCurrent = false;

      setTimeout(async () => {
        const account = await API.accounts.get(NULLUID, { include: 'roles,defs' })
        console.log("Done Account.api.get()=", account)
        Account.save(account);
      }, 100);

      return this;
    }

    page.current = function() {
      this._current(); // call base method
      isCurrent = true;
      console.log("ReportDefsCollectionPage: page.current")
      return this;
    };

    page.hidden = function() {
      isCurrent = false;
      console.log("ReportDefsCollectionPage: page.hidden")
    }
  })

  function createReport() {
    create = true;
    rpt = ReportDef.empty();
  }
</script>
  